<script setup lang="ts">
export type Color =
  | 'gray'
  | 'red'
  | 'red-neon'
  | 'purple'
  | 'teal' // blue
  | 'yellow'
  | 'orange'
  | 'basic'
  | 'green'
  | 'black';

type Props = {
  color: Color;
};
defineProps<Props>();
defineSlots<{
  default(props: unknown): VNode;
}>();
</script>

<template>
  <div class="badge" :class="{ [`badge--${color}`]: true }">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.badge {
  --color: var(--black);
  --background-color: transparent;

  display: inline-flex;

  padding: 0.0625rem 0.4375rem;

  border: 0.0625rem solid var(--border-color);
  background-color: var(--background-color);
  border-radius: 0.625rem;

  color: var(--color);
  font-size: var(--font-size-xs);
  font-weight: 500;
  text-transform: uppercase;

  &--gray {
    --color: var(--gray-basic);
    --border-color: var(--gray-basic);
  }

  &--red {
    --color: var(--red-bright);
    --border-color: var(--red-bright);
  }

  &--red-neon {
    --color: var(--red-neon-basic);
    --border-color: var(--red-neon-basic);
  }

  &--purple {
    --color: var(--purple-basic);
    --border-color: var(--purple-basic);
  }

  &--teal {
    --color: var(--teal-basic);
    --border-color: var(--teal-basic);
  }

  &--yellow {
    --color: var(--yellow-dark);
    --border-color: var(--yellow-dark);
  }

  &--orange {
    --color: var(--orange-basic);
    --border-color: var(--orange-basic);
  }

  &--green {
    --color: var(--green-basic);
    --border-color: var(--green-basic);
  }

  &--black {
    --color: var(--white);
    --border-color: var(--black);
    --background-color: var(--black);
  }
}
</style>
